import { render, staticRenderFns } from "./PopupApprovalNotes.vue?vue&type=template&id=52f38c83"
import script from "./PopupApprovalNotes.vue?vue&type=script&lang=js"
export * from "./PopupApprovalNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports